export const activitiesLoading = {
  eosp: { date: "", time: "", remarks: "" },
  "nor-tendered": { date: "", time: "", remarks: { reasondelay: "" } },
  "free-pratique": { date: "", time: "", remarks: "" },
  "pilot-onboard": { date: "", time: "", remarks: "" },
  anchored: { date: "", time: "", remarks: { reasondelay: "" } },
  "anchor-aweigh": { date: "", time: "", remarks: "" },
  "second-pilot-onboard": { date: "", time: "", remarks: "" },
  "changed-pilot-i": { date: "", time: "", remarks: "" },
  "changed-pilot-ii": { date: "", time: "", remarks: "" },
  lock: { date: "", time: "", remarks: "" },
  "first-line-ashore": {
    date: "",
    time: "",
    remarks: "",
  },
  "all-fast": { date: "", time: "", remarks: "" },
  "draft-arrival": { date: "", time: "", remarks: { fwd: "", aft: "" } },
  "bunkers-arrival": { date: "", time: "", remarks: { go: "", lng: "" } },
  "nor-received": { date: "", time: "", remarks: "" },
  "tank-inspection": { date: "", time: "", remarks: "" },
  "key-meeting-done": { date: "", time: "", remarks: "" },
  connected: {
    date: "",
    time: "",
    remarks: { manifold: "", "connection-size": "" },
  },
  "commenced-load": { date: "", time: "", remarks: "" },
  "stop-load": { date: "", time: "", remarks: "" },
  "start-load": { date: "", time: "", remarks: "" },
  "completed-load": { date: "", time: "", remarks: "" },
  "ullage-sampling": { date: "", time: "", remarks: "" },
  "calculations-done": {
    date: "",
    time: "",
    remarks: { shipfig: "", blfig: "", diff: "", percent: "" },
    remarksOrder: ["shipfig", "blfig", "diff", "percent"],
  },
  disconnected: { date: "", time: "", remarks: { reasondelay: "" } },
  "documents-onboard": { date: "", time: "", remarks: "" },
  "documents-signed": { date: "", time: "", remarks: { reasondelay: "" } },
  "pilot-onboard-departure": { date: "", time: "", remarks: "" },
  departure: { date: "", time: "", remarks: "" },
  "draft-departure": { date: "", time: "", remarks: { fwd: "", aft: "" } },
  "bunkers-departure": { date: "", time: "", remarks: { go: "", lng: "" } },
  "changed-pilot": { date: "", time: "", remarks: "" },
  "pilot-disembarked": {
    date: "",
    time: "",
    remarks: "",
  },
  sosp: { date: "", time: "", remarks: "" },
};
